import { Sidebar, SidebarContent } from '@/shared/ui/sidebar';
import LessonSidebar from '../../components/sidebar/LessonSidebar';
import { useSelector } from 'react-redux';
import { currentCourse } from '../../selectors/courseSelectors';

/**
 * Wraps the legacy LessonSidebar inside the shadcn Sidebar component.
 * Uses collapsible="offcanvas" so it renders as a Sheet on mobile.
 * No collapse button — always expanded on desktop.
 */
export function LessonSidebarShell() {
  const course = useSelector((s: unknown) => currentCourse(s as never));

  return (
    <Sidebar collapsible="offcanvas" className="border-r">
      <SidebarContent className="overflow-y-auto">
        <LessonSidebar currentCourse={course} />
      </SidebarContent>
    </Sidebar>
  );
}
